import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UniversityService} from '../../shared/services/university.service';
import {AlertService} from '../../shared/services/alert.service';
import {CounsellorService} from '../../shared/services/counsellor.service';
import {AdminService} from '../../shared/services/admin.service';
import {StorageService} from '../../shared/services/storage.service';

@Component({
    selector: 'app-counsellors',
    templateUrl: './counsellors.component.html',
    styleUrls: ['./counsellors.component.scss']
})
export class CounsellorsComponent implements OnInit {
    showSearch = false;
    assignedUniversities: any;
    id: any;
    data: any;
    updatePasswordForm: FormGroup;
    updateStatusForm: FormGroup;
    leadupdateStatusForm: FormGroup;
    inputTypePassword = 'password';
    allAdmins: any = [];
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    modalType: any;
    counsellors: any = [];
    universities: any = [];
    selectedCounsellor: any;
    contentHeader: object;
    user: any;
    uploadingProfileImageId: any;

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private adminService: AdminService,
                private alertService: AlertService,
                private counsellorService: CounsellorService) {
        this.user = StorageService.getItem('self');
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.updatePasswordForm = this.fb.group({
            'password': [''],

        });
        this.updateStatusForm = this.fb.group({
            'follow_up_status': [''],

        });
        this.leadupdateStatusForm = this.fb.group({
            'lead_follow_up_status': [''],

        });

        this.searchForm = this.fb.group({
            'added_by': [''],
           /* 'username': [''],
            'email': [''],
            'contact': [''],*/
        });
        this.get();
        this.getAdmins();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-counsellor').toggleOpen();
    }
    getAdmins(params: any = {}) {
        this.allAdmins = [];
        this.adminService.get({'page': -1}).subscribe(data => {
            if (data && data['data'].length > 0) {

                this.allAdmins = data['data'];
            } else {
                this.allAdmins = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    updateStatusModal(content, followups, type) {
      this.id = followups.user_id;
        this.modalType = type;
        this.updateStatusForm.patchValue({
            'follow_up_status': followups?.follow_up_status
        });
        this.modalService.open(content, {'size': 'sm'});
    }
    leadupdateStatusModal(content, followups, type) {
        this.id = followups.user_id;
        this.modalType = type;
        this.leadupdateStatusForm.patchValue({
            'lead_follow_up_status': followups?.lead_follow_up_status
        });
        this.modalService.open(content, {'size': 'sm'});
    }
    updatePasswordModal(content, id, type) {
        this.id = id;
        this.modalType = type;
        this.updatePasswordForm.patchValue({
            'password': ''
        });
        this.modalService.open(content, {'size': 'sm'});
    }

    search() {
        const params = {
            'added_by': (this.searchForm.value && this.searchForm.value.added_by) ? this.searchForm.value.added_by : '',
            /*   'username': (this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : '',
               'email': (this.searchForm.value && this.searchForm.value.email) ? this.searchForm.value.email : '',
               'contact': (this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : ''*/
        };
        this.get(params);
    }


    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;

        this.submitting = true;
        this.counsellors = [];
        this.counsellorService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.counsellors = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.counsellors = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }



    updatefollowupStatus() {
        this.submitted = true;
        if (!this.updateStatusForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'follow_up_status': (this.updateStatusForm.value.follow_up_status) ? this.updateStatusForm.value.follow_up_status : ''
            };
            this.submitting = true;
            this.counsellorService.updatefollowUpsStatus(this.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.updatePasswordForm.patchValue({
                    'follow_up_status': this.updateStatusForm.value.follow_up_status
                });
                this.modalService.dismissAll('');
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    leadupdatefollowupStatus() {
        this.submitted = true;
        if (!this.leadupdateStatusForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'lead_follow_up_status': (this.leadupdateStatusForm.value.lead_follow_up_status) ? this.leadupdateStatusForm.value.lead_follow_up_status : ''
            };
            this.submitting = true;
            this.counsellorService.leadupdatefollowUpsStatus(this.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.leadupdateStatusForm.patchValue({
                    'lead_follow_up_status': this.leadupdateStatusForm.value.lead_follow_up_status
                });
                this.modalService.dismissAll('');
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }


    updatePassword() {
        this.submitted = true;
        if (!this.updatePasswordForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'password': (this.updatePasswordForm.value && this.updatePasswordForm.value.password) ? this.updatePasswordForm.value.password : ''
            };
            this.submitting = true;
            this.counsellorService.updatePassword(this.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.updatePasswordForm.patchValue({
                    'password': '',
                });
                this.modalService.dismissAll('');
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'name': (this.searchForm && this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'username': (this.searchForm && this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : '',
            'email': (this.searchForm && this.searchForm.value && this.searchForm.value.email) ? this.searchForm.value.email : '',
            'contact': (this.searchForm && this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : ''
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }
    leadedit(data) {
        this.data = data;
        this.toggleSidebar();
    }


    onProfileImageSelected(event, counsellor) {
        if (!counsellor || !counsellor.user_id) {
            return;
        }
        this.uploadingProfileImageId = counsellor.id;
        const params = {
            type: 'PROFILE_IMAGE',
            fileType: 'NORMAL',
            user_id: counsellor.user_id
        };
        this.counsellorService.fileUpload(params, event).subscribe(data => {
            if (data && data['data']) {
                this.counsellorService.updateProfile(counsellor.user_id, {profile_image: data['data'].id}).subscribe(() => {
                    this.uploadingProfileImageId = undefined;
                    this.alertService.showSuccess({title: 'Success', message: 'Profile image uploaded successfully'});
                    this.get();
                }, error => {
                    this.uploadingProfileImageId = undefined;
                });
            } else {
                this.uploadingProfileImageId = undefined;
            }
        }, error => {
            this.uploadingProfileImageId = undefined;
        });
    }

    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.counsellorService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }
}
